import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import { OrderErpStatusCreateDefault } from "./types/OrderErpStatusCreateDefault";
import {
  OrderErpStatusUpdate,
  OrderErpStatusUpdateVariables
} from "./types/OrderErpStatusUpdate";

const orderErpStatusUpdate = gql`
  mutation OrderErpStatusUpdate($status: String!, $note: String!) {
    orderErpStatusUpdate(status: $status, note: $note) {
      erpStatusAndNotes {
        id
        status
        note
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useOrderErpStatusUpdateMutation = makeMutation<
  OrderErpStatusUpdate,
  OrderErpStatusUpdateVariables
>(orderErpStatusUpdate);

const orderErpStatusCreateDefault = gql`
  mutation OrderErpStatusCreateDefault {
    orderErpStatusCreateDefault {
      erpStatusAndNotes {
        id
        status
        note
      }
      errors {
        field
        message
      }
    }
  }
`;
export const useOrderErpStatusCreateDefaultMutation = makeMutation<
  OrderErpStatusCreateDefault,
  null
>(orderErpStatusCreateDefault);
